import { useNavigate } from "react-router-dom";
import axios from "axios";
import { STORAGE_KEYS } from "constants/appConstant";
import queryString from "query-string";
import StorageHelper from "utils/storeHelper";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export const getAuthInfo = async () => {
  return StorageHelper.getCookie(STORAGE_KEYS.token) || "";
};

const handleUnauthorized = async status => {
  if (status === 401) {
    await StorageHelper.removeCookie(STORAGE_KEYS.token);
    StorageHelper.removeLocalItem(STORAGE_KEYS.user);
    const navigator = useNavigate();
    await navigator("/auth/sign-in");
  }
};
// Set up default config for http requests here
// Please have a look at here `https://github.com/axios/axios#request- config` for the full list of configs
const axiosClient = axios.create({
  baseURL: SERVER_URL,
  headers: {
    "content-type": "application/json",
  },
  paramsSerializer: params => queryString.stringify(params),
});

axiosClient.interceptors.request.use(async config => {
  const token = await getAuthInfo();
  if (token) {
    config.headers["Auth-Token"] = `${token}`;
  }

  return config;
});

axiosClient.interceptors.response.use(
  async response => {
    await handleUnauthorized(response.data.status);
    return response;
  },
  async ({ response }) => {
    if (response) {
      const { status, data } = response;

      const responseError = {
        ...data,
        status,
      };
      // Handle errors
      await handleUnauthorized(status);
      throw responseError;
    }
  }
);

export default axiosClient;
